import React, { memo } from 'react';

const ActionButton = memo(({ text, func, param, disabled = false, styleName, submit }) => {
  const handleSubmit = () => {
    if (func) {
      if (param) {
        func(param);
      } else {
        func();
      }
    }
  };

  return (
    <button
      type={submit ? 'submit' : 'button'}
      className={styleName ? styleName : disabled ? 'disabled-action-item' : 'action-item'}
      onClick={handleSubmit}
      disabled={disabled}>
      {text}
    </button>
  );
});

export default ActionButton;
